import EventBus from "../services/event-bus";
import { EVENTS, base_url } from "./constants";
import ClientService from "../services/client-service";
import moment from "moment";
import UrlService from "../services/url-service";
import Cookies from "js-cookie";
import ModalService from "./modal-service";
import GetrestoLoadingModal from "../components/getresto-loading-modal.vue";
import DataStore from "./data-store";

let factory = {
	fromGetresto: false,
	errorMsg: "",
	errorInfo: "",
	successMsg: "",
};

export default factory;

init();

function init() {
	initComo();
	initGetresto();
}

function initComo() {
	let query = UrlService.fromQuery();

	if (query.como == "error") {
		showLoadingModal("Login Como");
		let info = "";
		let msg = "Le login a échoué; Vous pouvez continuer de manière anonyme";
		if (query.msg) {
			info = "; Cause de l'échec: " + query.msg;
		}
		setErrorMsg(msg, info);
	}
	UrlService.setQueryParam("como", undefined);
	UrlService.setQueryParam("msg", undefined);
}

function initGetresto() {
	let query = UrlService.fromQuery();

	if (query.getresto == "login") {
		activateGetrestoMode();
		ClientService.identity().then(identity => {
			if (!identity) {
				showLoadingModal();
				setErrorMsg("Echec du login");
			}
		});
	} else if (query.getresto == "denied") {
		activateGetrestoMode();
		showLoadingModal();
		setErrorMsg("Le login a été refusé; Vous pouvez continuer de manière anonyme");
	}
	UrlService.setQueryParam("getresto", undefined);
	if (Cookies.get("getresto") == "true") {
		factory.fromGetresto = true;
		console.log("getresto mode active");
	}
	EventBus.$on(EVENTS.shopChanged, shop => {
		if (!factory.fromGetresto) {
			return;
		}
		// apply custom config
		// shop.DefaultName = 'getresto - ' + shop.DefaultName;
		// toujours afficher le modal au depart
		shop.info.landingModal = true;
		// afficher le nouveau mode
		shop.info.checkoutHome = true;
		// afficher en liste
		shop.info.display.itemChildList = true;
		// utiliser le compte stuart de getresto
		DataStore.get(base_url + "/admin/shop/stuart-account-for-getresto", "Erreur paramètres de livraison").then(
			data => {
				// console.log('replacing shop.stuart_account',shop.stuart_account,'by',data.stuart_account)
				shop.stuart_account = data.stuart_account;
				shop.stuart_account_id = data.stuart_account.id;
			}
		);
		// appliquer le theme de getresto
		// default theme is {
		// color1: "#27cde6"
		// color1d: "#1d6f7c"
		// color2: "#e64e27"
		// color2d: "#ba4021"
		// }
		shop.Theme = {
			color1: "#fb8460",
			color1d: "#1fcae5",
			color2: "#410941",
			color2d: "#2fba16",
		};
	});
}

function activateGetrestoMode() {
	let in30minutes = moment().add(30, "minutes").toDate();
	Cookies.set("getresto", "true", { expires: in30minutes });
}

function showLoadingModal(title = "Login get-resto") {
	ModalService.open(GetrestoLoadingModal, { service: factory, title });
}

function setErrorMsg(msg: string, info = "") {
	factory.errorMsg = msg;
	factory.errorInfo = info;
}
